import type { SVGProps } from "react";
import * as React from "react";
const SvgAtLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.609 19.883C14.696 20.656 12.913 21 11.044 21c-5.761 0-9.065-2.9-9.065-7.969C1.979 6.995 6.239 3 12.652 3c5.566 0 9.327 3.007 9.327 7.56 0 3.824-2.022 6.058-4.979 6.058-1.5 0-2.5-.623-2.934-1.61-.718 1.052-2.088 1.739-3.327 1.739-2.456 0-3.934-1.525-3.934-4.081 0-3.072 1.804-5.22 4.39-5.22 1.175 0 2.153.387 2.718 1.053l.087-.86h3.044l-.435 4.06c-.065.688-.13 1.375-.13 1.826 0 .516.413.86 1 .86 1.304 0 2.108-1.204 2.108-3.438 0-3.909-2.282-5.799-7.065-5.799-4.848 0-8.152 3.05-8.152 7.69 0 3.78 2.456 6.014 6.76 6.014 1.848 0 3.175-.236 4.892-.945l.587 1.976Zm-4.913-5.713c1.043 0 1.76-.967 1.76-2.342 0-1.138-.521-1.804-1.412-1.804-1.044 0-1.761.967-1.761 2.363 0 1.117.522 1.782 1.413 1.782Z"
    />
  </svg>
);
export default SvgAtLine;
